import { authClient, type AuthClient } from './client.ts'

export type StepUpError = 'no_factor' | 'bad_code'

/** A fresh second-factor check for ONE sensitive action (releasing a machine, a Y* command): the server wants a code entered within the last 10 minutes,
 *  on top of the second-factor sign-in. Uses the account's verified TOTP factor (as the server lists it now); the server separately requires that the
 *  factor was approved. When this resolves without an error the new access token (its fresh `totp` time) is already in place, so the next call
 *  (`api.begin_online_action`, an admin endpoint) carries it. */
export async function stepUp(code: string, client: AuthClient = authClient): Promise<{ error?: StepUpError }> {
  const user = await client.user()
  const factor = user?.factors.find((f) => f.status === 'verified')
  if (!factor) return { error: 'no_factor' }
  const r = await client.verifyFactor(factor.id, code.replace(/\s/g, ''))
  return r.error ? { error: 'bad_code' } : {}
}
